export const CREATE_LCAPAF_STARTED = "CREATE_LCAPAF_STARTED";
export const CREATE_LCAPAF_COMPLETED = "CREATE_LCAPAF_COMPLETED";
export const CREATE_LCAPAF_FAILED = "CREATE_LCAPAF_FAILED";

export const UPDATE_LCAPAF_STARTED = "UPDATE_LCAPAF_STARTED";
export const UPDATE_LCAPAF_COMPLETED = "UPDATE_LCAPAF_COMPLETED";
export const UPDATE_LCAPAF_FAILED = "UPDATE_LCAPAF_FAILED";

export const GET_LCAPAFBYID_STARTED = "GET_LCAPAFBYID_STARTED";
export const GET_LCAPAFBYID_SUCCESS = "GET_LCAPAFBYID_SUCCESS";
export const GET_LCAPAFBYID_FAILED = "GET_LCAPAFBYID_FAILED";

export const GET_LCAPAFBYCHILDCASEID_STARTED = "GET_LCAPAFBYCHILDCASEID_STARTED";
export const GET_LCAPAFBYCHILDCASEID_SUCCESS = "GET_LCAPAFBYCHILDCASEID_SUCCESS";
export const GET_LCAPAFBYCHILDCASEID_FAILED = "GET_LCAPAFBYCHILDCASEID_FAILED";

export const GET_LCAPAFBYLISTCASEID_STARTED = "GET_LCAPAFBYLISTCASEID_STARTED";
export const GET_LCAPAFBYLISTCASEID_SUCCESS = "GET_LCAPAFBYLISTCASEID_SUCCESS";
export const GET_LCAPAFBYLISTCASEID_FAILED = "GET_LCAPAFBYLISTCASEID_FAILED";

export const GET_LCAPAFBYCOMPANYID_STARTED = "GET_LCAPAFBYCOMPANYID_STARTED";
export const GET_LCAPAFBYCOMPANYID_SUCCESS = "GET_LCAPAFBYCOMPANYID_SUCCESS";
export const GET_LCAPAFBYCOMPANYID_FAILED = "GET_LCAPAFBYCOMPANYID_FAILED";

export const GETALL_LCAPAF_STARTED = "GETALL_LCAPAF_STARTED";
export const GETALL_LCAPAF_SUCCESS = "GETALL_LCAPAF_SUCCESS";
export const GETALL_LCAPAF_FAILED = "GETALL_LCAPAF_FAILED";

export interface IVisacareLCAPAFData {
    status: {
        statusCode: number,
        statusDisplay: string,
        statusValue: boolean
    };
    items: Array<any>;
    CaseInput: {
        insert_datetime:Date,
        inserted_by:string,
        update_datetime:Date,
        updated_by:string
       
    };
    permission_id: number;
    isLoading: boolean;
    error: string;
}

export const createLCAPAFData = (input: any) => {
    return {
    type: CREATE_LCAPAF_STARTED,
    payload: "status",
    input: input
  };
};

export const updateLCAPAFData = (input: any) => {
    return {
    type: UPDATE_LCAPAF_STARTED,
    payload: "status",
    input: input
  };
};

 export const getLCAPAFById = (input) => {
 
     return {
         type: GET_LCAPAFBYID_STARTED ,
         payload: 'Value',
         input:input
     };
 };

 export const getLCAPAFByChildCaseId = (input) => {
 
    return {
        type: GET_LCAPAFBYCHILDCASEID_STARTED ,
        payload: 'Value',
        input:input
    };
};


export const getLCAPAFByListCaseId = (input) => {
 
    return {
        type: GET_LCAPAFBYLISTCASEID_STARTED ,
        payload: 'Value',
        input:input
    };
};

export const getLCAPAFByCompanyId = (input) => {
 
    return {
        type: GET_LCAPAFBYCOMPANYID_STARTED ,
        payload: 'Value',
        input:input
    };
};

export const getAllLCAPAFData = (input) => {
 
    return {
        type: GETALL_LCAPAF_STARTED ,
        payload: 'Value',
        input:input
    };
};